module.exports = __webpack_public_path__ + "static/media/Giraffiti_Verkaufsbedingungen.29513f78.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/theme/giraffiti/public/Giraffiti_Verkaufsbedingungen.pdf
// module id = 1136
// module chunks = 0